import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/hooks/use-theme";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import IBKRImport from "./pages/IBKRImport";
import ContentSummary from "./pages/ContentSummary";
import DBOrder from "./pages/DBOrder";
import SMASurveillance from "./pages/SMASurveillance";
import Help from "./pages/Help";
import CollectedData from "./pages/CollectedData";
import HedgeProtection from "./pages/HedgeProtection";
import DividendDashboard from "./pages/DividendDashboard";
import PerformanceTracker from "./pages/PerformanceTracker";
import PriceAlertsWatchlist from "./pages/PriceAlertsWatchlist";
import RiskDashboard from "./pages/RiskDashboard";
import EarningsCalendar from "./pages/EarningsCalendar";
import CriticalMacroIndicators from "./pages/CriticalMacroIndicators";
import CapitolTrades from "./pages/CapitolTrades";
import WeakSentiments from "./pages/WeakSentiments";
import CorrelationMatrix from "./pages/CorrelationMatrix";
import { WiseBoardLayout } from "./wiseboard/layout/WiseBoardLayout";
import WiseBoardDashboard from "./wiseboard/pages/WiseBoardDashboard";
import CasePipeline from "./wiseboard/pages/CasePipeline";
import ProjectWorkspace from "./wiseboard/pages/ProjectWorkspace";
import ResetPassword from "./pages/ResetPassword";
import UserProfile from "./pages/UserProfile";
import StockPriceGathering from "./pages/StockPriceGathering";

const queryClient = new QueryClient();

const App = () => (
  <ThemeProvider defaultTheme="light" storageKey="gaintracker-theme">
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/ibkr-import" element={<IBKRImport />} />
            <Route path="/content-summary" element={<ContentSummary />} />
            <Route path="/db-order" element={<DBOrder />} />
            <Route path="/sma-surveillance" element={<SMASurveillance />} />
            <Route path="/collected-data" element={<CollectedData />} />
            <Route path="/hedge-protection" element={<HedgeProtection />} />
            <Route path="/dividend-dashboard" element={<DividendDashboard />} />
            <Route path="/performance-tracker" element={<PerformanceTracker />} />
            <Route path="/price-alerts" element={<PriceAlertsWatchlist />} />
            <Route path="/risk-dashboard" element={<RiskDashboard />} />
            <Route path="/earnings-calendar" element={<EarningsCalendar />} />
            <Route path="/macro-indicators" element={<CriticalMacroIndicators />} />
            <Route path="/capitol-trades" element={<CapitolTrades />} />
            <Route path="/weak-sentiments" element={<WeakSentiments />} />
            <Route path="/correlation-matrix" element={<CorrelationMatrix />} />

            {/* WiseBoard routes */}
            <Route path="/wiseboard" element={<WiseBoardLayout />}>
              <Route index element={<WiseBoardDashboard />} />
              <Route path="case/:caseId" element={<CasePipeline />} />
              <Route path="case/:caseId/:projectId" element={<ProjectWorkspace />} />
            </Route>
            
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/profile" element={<UserProfile />} />
            <Route path="/stock-price-gathering" element={<StockPriceGathering />} />
            <Route path="/help" element={<Help />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ThemeProvider>
);

export default App;
